<template>
  <main>
    <fade-in-top-title class="title-interval">
      <h3>Wine_UENO</h3>
      <span>Html/Css/Js</span>
    </fade-in-top-title>
    <div class="container container-web">
      <work-contents-top  class="overflow-white">
        <img src="@/assets/images/workContents01_pc.png" alt="">
      </work-contents-top>
      <work-contents-text-team
      webSiteText="「Wine居酒屋 UENO」" />
      <div class="work-contents-wrapper">
        <work-contents-block title="CONCEPT">
          <div class="work-contents-group">
            <img class="pc" src="@/assets/images/workContents01_pc_02.png" alt="">
            <img class="sp" src="@/assets/images/workContents01_sp_02.png" alt="">
          </div>
        </work-contents-block>
        <work-contents-block title="INFORMATION / SHOP SEARCH">
          <div class="work-contents-group">
            <img class="pc" src="@/assets/images/workContents01_pc_03.png" alt="">
            <img class="sp" src="@/assets/images/workContents01_sp_03.png" alt="">
          </div>
        </work-contents-block>
        <work-contents-block title="RESERVATION">
          <div class="work-contents-group">
            <img class="pc" src="@/assets/images/workContents01_pc_04.png" alt="">
            <img class="sp" src="@/assets/images/workContents01_sp_04.png" alt="">
          </div>
        </work-contents-block>
        <work-contents-block title="SHOP LIST">
          <div class="work-contents-group">
            <img class="pc" src="@/assets/images/workContents01_pc_05.png" alt="">
            <img class="sp" src="@/assets/images/workContents01_sp_05.png" alt="">
          </div>
        </work-contents-block>
        <work-contents-block title="FOOTER">
          <div class="work-contents-group">
            <img class="pc" src="@/assets/images/workContents01_pc_06.png" alt="">
            <img class="sp" src="@/assets/images/workContents01_sp_06.png" alt="">
          </div>
        </work-contents-block>
      </div>
    </div>
    <router-link to="/work/workContents07">
      <work-slide-left></work-slide-left>
    </router-link>
    <router-link to="/work/workContents02">
      <work-slide-right></work-slide-right>
    </router-link>
  </main>
</template>



<script>
import FadeInTopTitle from '@/components/FadeInTopTitle.vue';
import WorkContentsTextTeam from '@/components/WorkContentsTextTeam.vue';
import WorkContentsTop from '@/components/WorkContentsTop.vue';
import WorkContentsBlock from '@/components/WorkContentsBlock.vue';
import WorkSlideLeft from '@/components/WorkSlideLeft.vue';
import WorkSlideRight from '@/components/WorkSlideRight.vue';

export default {
  components: {
    WorkContentsTextTeam,
    WorkContentsTop,
    WorkContentsBlock,
    WorkSlideLeft,
    WorkSlideRight,
    FadeInTopTitle
  }
}
</script>

<style lang="scss" scoped>

</style>